import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge"

// tailwind-merge only knows stock Tailwind. Without being told about the type and
// spacing ramps in tailwind.config.js it files `text-body` under text *colour*, so
// `cn("text-body text-muted-foreground")` silently dropped the size and
// `cn("text-primary", "text-micro")` dropped the colour (DESIGN.md §2).
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["micro", "meta", "body", "lede", "title", "display"],
      spacing: ["hair", "tight", "snug", "base", "loose", "section", "page"],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
